import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {LoadingController} from "@ionic/angular";
import {KeycloakService} from "keycloak-angular";

@Component({
  selector: 'app-level',
  templateUrl: './level.component.html',
  styleUrls: ['./level.component.scss'],
})
export class LevelComponent  implements OnInit {
  boritekok = []
  user$

  constructor(private http: HttpClient,private loadingCtrl: LoadingController,public keycloak: KeycloakService) {

  }

  async ngOnInit() {
    this.user$ = await this.keycloak.loadUserProfile();
    this.getData()
  }

  getData(){
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer `
    );
    this.http
      .get(
        '/api/boritek/list/203508',
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response:any) => {
          this.boritekok = response

        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }

}
